import './index.scss';
import Abolger from '../../../assets/images/Abolger.png';

const Logo = () => (
  <>
    <div className="logo-container">
      <img className="solid-logo" src={Abolger} alt="logo" />
    </div>
  </>

);
export default Logo;
